import { parse as yamlParse } from 'yaml';

import { DataContext, DataObject } from '../../api/models/data';
import { OBJECTTYPES, TpDataContext } from '../../data/interfaces';
import { TpETLDataContext, TpETLEntityTableObject } from './interfaces';
import { TpAssetInfo } from '../../data/assets/interfaces';

async function dataTableManifest(dataObject: DataObject) {
  const metaDataResponse = await fetch(dataObject.metadataUrl);
  const metaDataText = await metaDataResponse.text();
  const metadataObj = yamlParse(metaDataText);

  const entityTable: TpETLEntityTableObject = {
    dataObjectId: dataObject.tableId,
    name: metadataObj.displayName,
    description: metadataObj.description,
    entityType: metadataObj.entityType,
    columns: metadataObj.properties.map((col: any) => ({
      identifier: col.identifier,
      name: col.displayName,
      description: col.description ?? '',
      dataType: col.dataType,
    })),
  };

  return entityTable;
}

export async function buildETLDataContext(
  dataContextResponse: DataContext,
  assetInfo: TpAssetInfo,
): Promise<TpETLDataContext> {
  const dataTables = dataContextResponse.dataObjects.filter(
    (dataObject) => dataObject.objectType === OBJECTTYPES.ENTITY_TABLE,
  );
  const etlEntityDataTables = await Promise.all(dataTables.map(dataTableManifest));

  const dataContext: TpETLDataContext = {
    assetId: dataContextResponse.assetId,
    assetName: assetInfo.displayName,
    id: dataContextResponse.id,
    dataTables: etlEntityDataTables,
  };
  return dataContext;
}

export function dataContextToETLDataContext(dataContext: TpDataContext, assetInfo: TpAssetInfo): TpETLDataContext {
  const dataTables: TpETLEntityTableObject[] = dataContext.dataTables.map((dataTable) => ({
    dataObjectId: dataTable.id,
    name: dataTable.name,
    description: dataTable.description ?? '',
    entityType: dataTable.canonicalTypeId,
    columns: dataTable.columns.map((col) => ({
      identifier: col.id,
      name: col.name,
      description: col.description ?? '',
      dataType: col.valueType,
    })),
  }));

  const etlDataContext: TpETLDataContext = {
    assetId: dataContext.assetId,
    assetName: assetInfo.displayName,
    id: dataContext.id,
    dataTables: dataTables,
  };

  return etlDataContext;
}
